export default "__VITE_ASSET__5d7d3c5b__"